import type { Cell, Level } from "./types";
import { withinRadius } from "@jpjj/solver-core/geometry";
import { RADIUS } from "./levels";
import { state } from "./state";

/** Stable "r-c" key for a cell. */
export const key = (r: number, c: number): string => r + "-" + c;

/** True if a noria at (nr,nc) waters the cell (r,c) — the shared coverage test. */
export function covers(nr: number, nc: number, r: number, c: number): boolean {
  return withinRadius(nr, nc, r, c, RADIUS);
}

/** Bounds check against the current level. */
export function inBounds(r: number, c: number): boolean {
  return r >= 0 && c >= 0 && r < state.rows() && c < state.cols();
}

/** Demand points (palms) of a level, as [row, col]. */
export function levelDemands(L: Level): Cell[] {
  return L.trees.map(([r, c]): Cell => [r, c]);
}

/** Cells on which a noria may be placed (not a palm, not a boulder). */
export function levelCandidates(L: Level): Cell[] {
  const blocked = new Set<string>();
  for (const [r, c] of L.trees) blocked.add(key(r, c));
  for (const [r, c] of L.rocks) blocked.add(key(r, c));
  const out: Cell[] = [];
  for (let r = 0; r < L.rows; r++)
    for (let c = 0; c < L.cols; c++)
      if (!blocked.has(key(r, c))) out.push([r, c]);
  return out;
}
